module.exports = __webpack_public_path__ + "static/media/Pa.3cd37a9f.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/audio/row4/Pa.mp3
// module id = 77
// module chunks = 0